<template>
  <div id="app">
    <div class="header">
      <img @click="fanhui" class="img" src="../img/faunhui1.png" alt="" />
      <span class="header-span">{{ title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: () => {
        return String;
      },
    },
    id: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    fanhui() {
      if (this.id == "MyShop") {
        this.$router.push({
          name: "MyShop",
        });
      } else {
        this.$router.back();
      }
    },
  },
  mounted() {},
};
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 5rem;
  border-bottom: 0.1rem solid #999;
  background-image: url(../../assets/Topbeijing22.jpg);
  background-size: 100% 100%;
  color: #fff;
  z-index: 999999;
}
.img {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 1rem;
  height: 2rem;
  margin-left: 1rem;
  z-index: 999999;
}
.header-span {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  height: 3rem;
  color: #fff;
  font-size: 1.8rem;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/common/vue/head.vue